import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNavProfile.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNavProfile.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNavProfile.vue?vue&type=script&lang=js
// module id = ST7e
// module chunks = 77